import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import Button from '../ui/Button';

const Footer = () => {
  const services = [
    { name: "Guest Posts", path: "/services/guest-posts" },
    { name: "Press Releases", path: "/services/press-releases" },
    { name: "Link Insertions", path: "/services/link-insertions" },
    { name: "Reddit Marketing", path: "/services/reddit" },
    { name: "Quora Marketing", path: "/services/quora" },
    { name: "YouTube SEO", path: "/services/youtube" },
    { name: "Google Maps SEO", path: "/services/google-maps" },
    { name: "Product Reviews", path: "/services/product-reviews" },
    { name: "Brand Mentions", path: "/services/brand-mentions" }
  ];

  return (
    <footer className="bg-[#070b14] border-t border-white/5 pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          {/* Logo & About */}
          <div className="col-span-1 lg:pr-4">
            <Link to="/" className="flex items-center gap-2 mb-6 group inline-flex">
              <img 
                src="https://media-manager-c.questera.ai/greta-media/22508bb601940b4e20f7d160303c50efd71c7583e6bf992668d180d798243f38c2166642d2b71e0a7892275161f0f512/images/aW1hZ2UvcG5n/af7c6028487921f1e2e96f2e43edef8f.png" 
                alt="PRBoost Logo" 
                className="w-8 h-8 rounded-lg object-cover group-hover:scale-110 transition-transform" 
              />
              <span className="text-xl font-bold tracking-tight text-white">PRBoost</span>
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed mb-6 max-w-sm">
              The premier backlinks marketplace for agencies and brands to scale SEO with real authority signals.
            </p>
            <div className="flex gap-4">
              <a 
                href="https://www.facebook.com/prboost.io" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-slate-400 hover:text-white transition-colors" 
                aria-label="Facebook"
              >
                <SafeIcon icon={FiIcons.FiFacebook} />
              </a>
              <a 
                href="https://www.instagram.com/prboost.io/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-slate-400 hover:text-white transition-colors" 
                aria-label="Instagram"
              >
                <SafeIcon icon={FiIcons.FiInstagram} />
              </a>
            </div>
          </div>

          {/* Services Column */}
          <div>
            <h4 className="text-white font-semibold mb-6">Services</h4>
            <ul className="flex flex-col space-y-3 text-sm text-slate-400">
              {services.map((service, idx) => (
                <li key={idx}>
                  <Link to={service.path} className="hover:text-blue-400 transition-colors">
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Column */}
          <div>
            <h4 className="text-white font-semibold mb-6">Legal</h4>
            <ul className="flex flex-col space-y-3 text-sm text-slate-400">
              <li><Link to="/privacy-policy" className="hover:text-blue-400 transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms-of-service" className="hover:text-blue-400 transition-colors">Terms of Service</Link></li>
              <li><Link to="/refund-policy" className="hover:text-blue-400 transition-colors">Refund Policy</Link></li>
            </ul>
          </div>

          {/* Create an Account Column */}
          <div>
            <h4 className="text-white font-semibold mb-6">Create an Account</h4>
            <div className="w-full max-w-[200px]">
              <Button href="https://app.prboost.io/" variant="primary" className="w-full">
                Get Started
              </Button>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row items-center justify-between">
          <p className="text-slate-500 text-sm mb-4 md:mb-0">
            &copy; {new Date().getFullYear()} PRBoost. All rights reserved.
          </p>
          <div className="text-slate-500 text-sm flex items-center gap-1">
            Built with <span className="text-red-500 mx-1">❤️</span> by 
            <a 
              href="https://rotev.io" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-blue-400 hover:text-blue-300 transition-colors font-medium ml-1"
            >
              Rotev
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
